import React from "react";

const Modal = ({children, show}) => {
  if (!show)
    return null;
  
  return (
    <div className="absolute inset-0 bg-slate-900/[.5] z-[999] overflow-auto">
      <div className="flex min-h-full justify-center items-center">
        <div className="bg-white rounded-xl p-8 m-4 min-w-[24rem] max-w-full md:max-w-[850px]">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;